import { useEffect } from 'react';

/**
 * Live export progress (spec §8).
 *
 * EventSource reconnects on its own if the connection drops, and the exports
 * screen polls as well, so a network that eats long-lived connections means
 * slower updates rather than none.
 */
export function useExportEvents(onUpdate: (id: number, status: string) => void): void {
  useEffect(() => {
    let source: EventSource | undefined;
    try {
      source = new EventSource('/api/v1/events', { withCredentials: true });
    } catch {
      return; // no stream available; the poll below still refreshes
    }

    const handler = (event: MessageEvent<string>): void => {
      try {
        const data = JSON.parse(event.data) as { id: number; status: string };
        onUpdate(data.id, data.status);
      } catch {
        // A malformed frame is not worth tearing the stream down for.
      }
    };

    source.addEventListener('export.updated', handler as EventListener);
    return () => {
      source?.removeEventListener('export.updated', handler as EventListener);
      source?.close();
    };
  }, [onUpdate]);
}
